import "drag-drop-touch";
import "./shims";
import "./merge-globals";
import { browserCheck, init } from "./game";
import { DEV } from "./env";
import { watchLatestCommit } from "./commit-watcher";

document.addEventListener("contextmenu", event => {
  event.preventDefault();
});

if (browserCheck()) init();
if (DEV) watchLatestCommit();
